/**
 * @desc 查询首页横幅详情
 */
import { BannerEntity } from '@eastcoal/api/content/interface'
import { apiFetch } from '@eastcoal/common/utils/fetcher/api'
import {
  RequestOptions,
  ApiConfig
} from '@eastcoal/common/utils/fetcher/interface'

export type QueryBannerParameter = {
  id?: string
}

const method = 'GET'
const url = '/content/operation/banner'

export const queryBannerApi = (
  params?: QueryBannerParameter,
  config?: Partial<RequestOptions<ApiConfig>>
) => {
  return apiFetch<BannerEntity>({
    method,
    url,
    params,
    ...config
  })
}

queryBannerApi.method = method
queryBannerApi.url = url
